/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2025-01-21 14:45:56
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-01-23 10:50:50
 * @FilePath: \crane-safety-manager\src\slices\poles\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'pole';
const tname = '监测杆';

export const getAll = createAsyncThunk(`${prefix}/get-all`, async function (siteId) {
    const params = {};
    if (!_.isEmpty(siteId)) {
        params['siteId'] = siteId;
    }
    const { data } = await APIClient.get('/poles', { params });
    return data;
});

export const create = createAsyncThunk(`${prefix}/create`, async function (payload) {
    try {
        const response = await APIClient.post('/poles', payload);
        ToastHelper.createSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.createFailed(tname);
        throw error;
    }
});

export const update = createAsyncThunk(`${prefix}/update`, async function (payload) {
    try {
        const response = await APIClient.put(`/poles/${payload.id}`, payload);
        ToastHelper.updateSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.updateFailed(tname);
        throw error;
    }
});

export const remove = createAsyncThunk(`${prefix}/remove`, async function (id) {
    try {
        await APIClient.delete(`/poles/${id}`);
        ToastHelper.removeSucceeded(tname);
        return id;
    } catch (error) {
        ToastHelper.removeFailed(tname);
        throw error;
    }
});

export const getById = createAsyncThunk(`${prefix}/get-by-id`, async function (id) {
    const { data } = await APIClient.get(`/poles/${id}`);
    return data;
});

export const getLogs = createAsyncThunk(`${prefix}/logs`, async function (poleId) {
    const { data } = await APIClient.get(`/poles/${poleId}/logs`);
    return data;
});

export const getAlarmLogs = createAsyncThunk(`${prefix}/alarm_logs`, async function (payload) {
    const { data } = await APIClient.get(`/poleLogs`,{params: payload});
    return data;
});
